export default __webpack_public_path__ + "static/media/A538.ac38cb30.webp";